
import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getBlogDetail } from '../lib/api';

const BASE   = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
const imgSrc = (url) => !url?null:url.startsWith('http')?url:`${BASE}${url}`;

export default function BlogDetails() {
  const { slug } = useParams();
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');

  useEffect(() => {
    setLoading(true);
    getBlogDetail(slug)
      .then(setData)
      .catch(()=>setError('Post not found'))
      .finally(()=>setLoading(false));
  }, [slug]);

  if (loading) return (
    <div style={{ paddingTop:120, paddingBottom:80, maxWidth:760, margin:'0 auto', padding:'120px 24px 80px' }} className="animate-pulse">
      <div style={{ height:16, background:'var(--grey)', width:'30%', marginBottom:20 }} />
      <div style={{ height:40, background:'var(--grey)', width:'80%', marginBottom:16 }} />
      <div style={{ height:12, background:'var(--grey)', width:'50%', marginBottom:40 }} />
      <div style={{ aspectRatio:'16/9', background:'var(--grey)', marginBottom:40 }} />
      {Array.from({length:8}).map((_,i) => <div key={i} style={{ height:12, background:'var(--grey)', marginBottom:10, width:i%3===2?'70%':'100%' }} />)}
    </div>
  );

  if (error) return (
    <div style={{ paddingTop:120, textAlign:'center', color:'var(--grey-mid)', fontSize:14 }}>
      <p style={{ marginBottom:24 }}>{error}</p>
      <Link to="/blogs" style={{ fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:600, color:'var(--dark)' }}>← Back to Journal</Link>
    </div>
  );

  const { post, related, prev, next } = data || {};
  if (!post) return null;

  return (
    <div style={{ paddingTop:64, minHeight:'100vh' }}>

      {/* Cover */}
      {post.cover_img && (
        <div style={{ height:440, overflow:'hidden', background:'var(--dark)' }}>
          <img src={imgSrc(post.cover_img)} alt={post.title} style={{ width:'100%', height:'100%', objectFit:'cover', opacity:0.75 }} />
        </div>
      )}

      {/* Article */}
      <article style={{ maxWidth:760, margin:'0 auto', padding:'52px 24px 80px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:18 }}>
          <span style={{ fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--gold)', fontWeight:600 }}>{post.category}</span>
          <span style={{ color:'var(--grey)', fontSize:11 }}>·</span>
          <span style={{ fontSize:12, color:'var(--grey-mid)' }}>{new Date(post.created_at).toLocaleDateString('en-IN',{day:'2-digit',month:'long',year:'numeric'})}</span>
          <span style={{ color:'var(--grey)', fontSize:11 }}>·</span>
          <span style={{ fontSize:12, color:'var(--grey-mid)' }}>By {post.author}</span>
        </div>

        <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,44px)', fontWeight:300, color:'var(--dark)', lineHeight:1.2, marginBottom:36, letterSpacing:'-0.01em' }}>{post.title}</h1>

        <div style={{ fontSize:14, color:'var(--grey-dark)', lineHeight:2, borderTop:'1px solid var(--grey)', paddingTop:36 }}
          dangerouslySetInnerHTML={{ __html: post.content }} />

        {/* Tags */}
        {post.tags && post.tags.length > 0 && (
          <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:40, paddingTop:28, borderTop:'1px solid var(--grey)' }}>
            {post.tags.map(t => (
              <span key={t} style={{ fontSize:11, padding:'4px 12px', border:'1px solid var(--grey)', color:'var(--grey-dark)', letterSpacing:'0.08em' }}>{t}</span>
            ))}
          </div>
        )}
      </article>

      {/* Prev / Next */}
      {(prev || next) && (
        <div style={{ borderTop:'1px solid var(--grey)', padding:'32px 24px', display:'flex', justifyContent:'space-between', gap:16, maxWidth:760, margin:'0 auto' }}>
          {prev
            ? <Link to={`/blogs/${prev.slug}`} style={{ fontSize:12, color:'var(--dark)', textDecoration:'none', fontWeight:500 }}>← {prev.title}</Link>
            : <span />
          }
          {next && <Link to={`/blogs/${next.slug}`} style={{ fontSize:12, color:'var(--dark)', textDecoration:'none', fontWeight:500 }}>{next.title} →</Link>}
        </div>
      )}

      {/* Related */}
      {related && related.length > 0 && (
        <div style={{ padding:'52px 40px 80px', background:'var(--cream)' }}>
          <div style={{ maxWidth:1200, margin:'0 auto' }}>
            <h3 style={{ fontFamily:'var(--font-display)', fontSize:28, fontWeight:300, color:'var(--dark)', marginBottom:28 }}>Related Articles</h3>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:20 }}>
              {related.map(r => (
                <Link key={r.id} to={`/blogs/${r.slug}`} style={{ textDecoration:'none', color:'inherit', border:'1px solid var(--grey)', background:'#fff', padding:'20px 20px 22px' }}>
                  <div style={{ fontSize:10, letterSpacing:'0.18em', textTransform:'uppercase', color:'var(--gold)', fontWeight:600, marginBottom:8 }}>{r.category}</div>
                  <h4 style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:300, color:'var(--dark)', lineHeight:1.3 }}>{r.title}</h4>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
